import "./styles/global.css";

import SEO           from "./components/SEO";
import Navbar        from "./components/layout/Navbar";
import Footer        from "./components/layout/Footer";
import Hero          from "./components/sections/Hero";
import TrustStrip    from "./components/sections/TrustStrip";
import About         from "./components/sections/About";
import StatsStrip    from "./components/sections/StatsStrip";
import Services      from "./components/sections/Services";
import GalleryTicker from "./components/sections/GalleryTicker";
import JobListings   from "./components/sections/JobListings";
import CareersAbroad from "./components/sections/CareersAbroad";
import Contact       from "./components/sections/Contact";

export default function App() {
  return (
    <>
      <SEO />
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <About />
        <StatsStrip />
        <Services />
        <GalleryTicker />
        <JobListings />
        <CareersAbroad />
        <Contact />
      </main>
      <Footer />
    </>
  );
}